import { VoucherCategoryListPage } from '@/features/voucher-category/pages/VoucherCategoryListPage'
import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/admin/voucher-category/')({
  beforeLoad({ context }) {
    if (!context.authAdapter.can({ permissions: ["voucher_category.view"] })) {
      throw redirect({ to: "/403" });
    }
  },
  component: VoucherCategoryListPage,
})
